import *  as ActionTypes from "./contact-usActionTypes";

const initialState = {
    isLoading: false,
    isSaved: false,
    contactus: []
};

export const contactUsReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.CREATE_CONTACT_US:
            return {
                ...state,
                isLoading: true,
                isSaved: false,
            }
        case ActionTypes.CREATE_CONTACT_US_FAILURE:
            return {
                ...state,
                isLoading: false,
            }
        case ActionTypes.CREATE_CONTACT_US_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSaved: true,
            }
        case ActionTypes.DELETE_CONTACT_US:
            return {
                ...state,
                isLoading: true,
                isSaved: false,
            }
        case ActionTypes.DELETE_CONTACT_US_FAILURE:
            return {
                ...state,
                isLoading: false,
            }
        case ActionTypes.DELETE_CONTACT_US_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSaved: true,
            }
        case ActionTypes.GET_CONTACT_US:
            return {
                ...state,
                isLoading: true,
            }
        case ActionTypes.GET_CONTACT_US_FAILURE:
            return {
                ...state,
                isLoading: false,
            }
        case ActionTypes.GET_CONTACT_US_SUCCESS:
            return {
                ...state,
                isLoading: false,
                contactus: action?.payload?.data || []
            }
        case ActionTypes.UPDATE_CONTACT_US:
            return {
                ...state,
                isLoading: true,
                isSaved: false,
            }
        case ActionTypes.UPDATE_CONTACT_US_FAILURE:
            return {
                ...state,
                isLoading: false,
            }
        case ActionTypes.UPDATE_CONTACT_US_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSaved: true,
            }
        default:
            return state

    }
}